import { createFileRoute } from "@tanstack/react-router";
import { ConceptGrid } from "@/components/site/ConceptGrid";
export const Route = createFileRoute("/koncept/")({
  head: () => ({
    meta: [
      { title: "Eventkoncept för företag och mässor | Event Sverige" },
      {
        name: "description",
        content:
          "Hitta rätt upplägg för mingel, kickoff, arkadfest eller mässa. Tydliga eventkoncept med värd och stämningsljus. Be om en samlad offert.",
      },
    ],
    links: [{ rel: "canonical", href: "https://eventsverige.se/koncept" }],
  }),
  component: () => (
    <div className="concept-site experience-wrap experience-section">
      <p className="eyebrow">Från första mötet till sista matchen</p>
      <h1>Välj er upplevelse.</h1>
      <p className="page-intro">
        Ett färdigt upplägg ger dagen ett innehåll och gästerna något att samlas kring. Vi anpassar
        genomförandet efter er lokal, grupp och önskade känsla.
      </p>
      <ConceptGrid />
    </div>
  ),
});
